export default "<script src=\"../js/oidc-client.js\"></script>\r\n<script src=\"/js/signin-callback.js\"></script>\r\n";